<template>
  <div class="popup-full  partner-register-change-popup">
    <div class="popup-full__wrap">
      <button type="button"
              class="popup-full__close"
              @click="close">
        <BaseSvg name="ico-close"/>
      </button>

      <div class="popup-full__scroll">
        <div class="popup-full__content  partner-register-change-popup__content">
          <BasePreloader v-if="pending"/>

          <div class="partner-register-change-popup__title">
            {{ $tPartnersRegisteredChangePopup('title') }}
          </div>

          <BaseInput :label="$tPartnersRegisterPopup('input_full_name')"
                     v-model="inputs.fio.value"
                     :error="inputs.fio.error"
                     class="partner-register-change-popup__input"/>
          <BaseInput :label="$tPartnersRegisteredChangePopup('input_login')"
                     :value="agent.customer_data.login"
                     disabled
                     class="partner-register-change-popup__input"/>

          <BaseCheckbox v-model="changePassword"
                        :label="$tPartnersRegisteredChangePopup('change_password')"
                        class="partner-register-change-popup__input"/>

          <div v-if="changePassword"
               class="partner-register-change-popup__password-wrap">
            <BasePreloader v-if="!isSentCode && pendingGetCode"/>

            <BaseInput :label="$tPartnersRegisteredChangePopup('Current password')"
                       :value="agent.customer_data.password"
                       disabled
                       class="partner-register-change-popup__input"/>
            <BaseInput :label="$tPartnersRegisteredChangePopup('input_new_password')"
                       :sub="`(${inputs.password.charactersQuantity} ${$tPartnersRegisteredChangePopup('input_characters')})`"
                       v-model="inputs.password.value"
                       :error="inputs.password.error"
                       type="password"
                       autocomplete="new-password"
                       v-mask="getMaskCharactersQuantity(inputs.password.charactersQuantity)"
                       class="partner-register-change-popup__input"/>
            <BaseInput :label="$tPartnersRegisteredChangePopup('input_new_password_repeat')"
                       v-model="inputs.re_password.value"
                       :error="inputs.re_password.error"
                       type="password"
                       autocomplete="new-password"
                       v-mask="getMaskCharactersQuantity(inputs.re_password.charactersQuantity)"
                       class="partner-register-change-popup__input"/>
          </div>

          <div class="partner-register-change-popup__code-wrap">
            <div class="partner-register-change-popup__code-title">
              {{ $tPartnersRegisteredChangePopup('code_title') }}
            </div>
            <div class="partner-register-change-popup__code-text  text">
              <p>
                {{
                  $tPartnersRegisteredChangePopup('code_description')
                }}
              </p>
            </div>

            <div class="partner-register-change-popup__code-row">
              <BaseInput v-model="inputs.sms_code.value"
                         :error="inputs.sms_code.error"
                         class="partner-register-change-popup__code-input  _white  _shadow"/>
              <SignInFormTimer v-if="showTimer"
                               :durationS="timerDurationS"
                               @end="onTimerEnd"
                               class="partner-register-change-popup__code-timer"/>
              <button v-else
                      @click.prevent="getCode"
                      class="partner-register-change-popup__code-btn-refresh  base-btn  base-btn--outline-dark">
                {{ $tPartnersRegisteredChangePopup('code_get_btn') }}
                <BasePreloader v-if="isSentCode && pendingGetCode"/>
              </button>
            </div>
            <div v-if="message" class="sign-in-form__col  _col-full">
              <BaseAlert :value="message" class="sign-in-form__message  _message"/>
            </div>
          </div>

          <BaseAlert :value="overallErrorsMix"
                     class="partner-register-change-popup__error  _warning"/>

          <button @click.prevent="send"
                  class="partner-register-change-popup__btn  base-btn  base-btn--green">
            {{ $tPartnersRegisteredChangePopup('save_btn') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import {blockScroll, unBlockScroll} from '@/helpers/scroll'
  import formMixins from '@/mixins/formMixins'
  import SignInFormTimer from '@/components/SignIn/SignInFormTimer'

  export default {
    name: 'PartnersRegisteredChangePopup',
    mixins: [formMixins],
    components: {
      SignInFormTimer
    },
    props: {
      agent: Object
    },
    data() {
      return {
        pending: false,

        changePassword: false,

        inputs: {
          customer_id: {
            value: null,
          },
          fio: {
            value: null,
          },
          login: {
            value: null
          },
          password: {
            value: null,
            charactersQuantity: 8,
          },
          re_password: {
            value: null,
            charactersQuantity: 8,
          },
          sms_code: {
            value: null,
          },
          phone: {
            value: null,
          },
        },

        timerDurationS: 60,
        pendingGetCode: false,
        isSentCode: false,
        showTimer: false
      }
    },
    computed: {},
    methods: {
      close() {
        this.$emit('close')
      },
      getCode() {
        if(this.pendingGetCode) return

        this.pendingGetCode = true

        this.message = null
        this.resetErrorsMix(this.inputs)
        const sendData = this.createSendDataMix(this.inputs)
        sendData.force = this.sentCode

        http.post('/api/auth/send-code', sendData).then(({data}) => {
          this.isSentCode = true

          if (data.status === 'NOT_NEED_SEND') {
            this.showTimer = false
            this.sentCode = true
          } else {
            this.showTimer = true
          }

          this.message = data.message
        }).catch((error => {
          this.errorHandlerMix(error)
        })).finally(() => {
          this.pendingGetCode = false
        })
      },
      send() {
        this.pending = true
        this.resetErrorsMix(this.inputs)

        const sendData = this.createSendDataMix(this.inputs)

        if(!this.changePassword) {
          delete sendData.password
          delete sendData.re_password
        }

        http.post('/api/cabinet/agent/change', sendData)
          .then(({data}) => {
            this.$vModal.open('successfully-sent', {
              title: data.data.message
            })

            this.$emit('change', data.data.customer_data)

            this.close()
          })
          .catch(e => {
            this.errorHandlerMix(e, this.inputs)
          })
          .finally(() => {
            this.pending = false
          })
      },
      getMaskCharactersQuantity(quantity) {
        let a = ''

        for (let i = 0; i < quantity; i++) {
          a += 'X?'
        }

        return a
      },
      onTimerEnd() {
        this.showTimer = false
      },
    },
    watch: {
      changePassword(value) {
        if(value) return

        this.inputs.password.value = null
        this.inputs.re_password.value = null
      }
    },
    created() {
      blockScroll()

      this.inputs.customer_id.value = this.agent.customer_data.id
      this.inputs.fio.value = this.agent.customer_data.fullname
      this.inputs.login.value = this.agent.customer_data.login
      this.inputs.phone.value = this.$store.state.user.profile.phone

      this.getCode()
    },
    beforeDestroy() {
      unBlockScroll()
    }
  }
</script>
